var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/music"
  }, /*#__PURE__*/React.createElement("g", {
    id: "music"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.47195 17.9166C6.8361 17.9166 7.94195 16.8107 7.94195 15.4466C7.94195 14.0824 6.8361 12.9766 5.47195 12.9766C4.10781 12.9766 3.00195 14.0824 3.00195 15.4466C3.00195 16.8107 4.10781 17.9166 5.47195 17.9166Z",
    stroke: "#0082CD",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 13.8001V4.14177C17 2.08344 15.7096 1.79844 14.4034 2.15469L9.46336 3.50052C8.56086 3.74594 7.94336 4.45844 7.94336 5.4876V7.20552V8.36135V15.4389",
    stroke: "#0082CD",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.5266 16.2701C15.8908 16.2701 16.9966 15.1642 16.9966 13.8001C16.9966 12.4359 15.8908 11.3301 14.5266 11.3301C13.1625 11.3301 12.0566 12.4359 12.0566 13.8001C12.0566 15.1642 13.1625 16.2701 14.5266 16.2701Z",
    stroke: "#0082CD",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.94336 8.03665L17 5.56665",
    stroke: "#0082CD",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.1cea42ea0fd6e31acfbac5fc7a3de87d.svg";
export { ForwardRef as ReactComponent };